/* eslint-disable array-callback-return */
import React, { useState } from "react";
import FrequencySection from "shared/config/FrequencySection";
import Button from "../Button";
import Modal from "../Modal";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { updateFrequency } from "app/subscriptions/actions";
import ErrorHandling from "shared/ErrorHandling";
import moment from "moment";
import styles from "./EditFrequencyModal.module.scss";

const EditFrequencyModal = ({
    currentFrequency,
    nextOrderDate,
    isOpen,
    handleClose,
    subscriptionId,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const scheduledOrdersPath = `/subscriptions/${subscriptionId}/deliveries`;
    const [frequency, setFrequency] = useState(currentFrequency);
    const [showMore, setShowMore] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [successState, setSuccessState] = useState(null);

    function handleCloseAndReset() {
        handleClose();
        setTimeout(() => {
            setError(null);
            setSuccessState(null);
            setShowMore(false);
        }, 1000);
    }

    return (
        <Modal
            size="lg"
            isOpen={isOpen}
            handleClose={handleCloseAndReset}
            title="Edit frequency"
            subtitle="How often do you want to receive your coffee deliveries?"
            titleClassName={styles.title}
            subtitleClassName={styles.subtitle}
            successState={successState}
        >
            <FrequencySection
                frequency={frequency}
                currentFrequency={currentFrequency}
                onFrequencySelect={setFrequency}
                showMore={showMore}
            />
            {nextOrderDate && (
                <div className={styles.nextDelivery}>
                    <p className={styles.nextDeliveryLabel}>Next delivery</p>
                    <p className={styles.nextDeliveryDate}>
                        {moment(nextOrderDate, "YYYY-MM-DD").format(
                            "D MMM YYYY",
                        )}
                    </p>
                </div>
            )}
            <div>
                <p className={styles.changeBackNote}>
                    Change it back any time from{" "}
                    <a
                        className={styles.changeBackLink}
                        href={scheduledOrdersPath}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClose();
                            history.push(scheduledOrdersPath);
                        }}
                    >
                        your account.
                    </a>
                </p>
            </div>
            <div className={styles.footer}>
                <ErrorHandling error={error} />
                <div className={styles.actions}>
                    <Button
                        btnType="primary"
                        isLoading={isSubmitting}
                        onClick={() => {
                            setSubmitting(true);
                            dispatch(
                                updateFrequency(subscriptionId, {
                                    interval: frequency.interval,
                                    period: frequency.period,
                                }),
                            )
                                .then((data) => {
                                    setSuccessState({
                                        title: "Your delivery frequency has successfully been updated",
                                        subtitle: `You will receive your coffee every ${
                                            data.interval > 1
                                                ? data.interval
                                                : ""
                                        } ${data.period}${
                                            data.interval > 1 ? "s" : ""
                                        } - with your next charge date scheduled for the ${moment(
                                            data.next_dispatch
                                                ? data.next_dispatch.order_date
                                                : data.paused_until,
                                        ).format("DD/MM/YYYY")}.`,
                                    });
                                })
                                .catch((err) => setError(err))
                                .finally(() => setSubmitting(false));
                        }}
                        className={styles.updateButton}
                    >
                        Update
                    </Button>
                    <Button
                        btnType="tertiary"
                        className={styles.cancelButton}
                        onClick={handleCloseAndReset}
                    >
                        Cancel
                    </Button>
                </div>
                <Button
                    btnType="secondary"
                    className={styles.toggleButton}
                    onClick={() => setShowMore(!showMore)}
                >
                    {!showMore ? "More options" : "Fewer options"}
                </Button>
            </div>
        </Modal>
    );
};

export default EditFrequencyModal;
